import ModalBodyCopy from './component.styles.js'
export default ModalBodyCopy
